export default "/images/datatable-checked.svg?77a83bdf2def5c201bad68b3b051176a";